module.exports = __webpack_public_path__ + "static/media/btc.2c326cbe.svg";